export default __webpack_public_path__ + "svg/4ab60f004932cbf6177327957542ce55.svg";